import { CommentReadDto } from "functions/api/comments/interface";
import { CommentFilterOptionValue } from "./interface";
import { isCommentVisible } from "./isCommentVisible";

/**
 * Check if a comment thread should be displayed based on the filter and resolved status.
 *
 * @param id - The ID of the comment thread
 * @param comments - The list of all comments
 * @param commentFilter - The filter criteria (all, open, or resolved)
 * @returns True if the comment thread should be displayed
 */
export const shouldShowCommentThread = (
  id: string,
  comments: CommentReadDto[],
  commentFilter: CommentFilterOptionValue,
): boolean => {
  if (commentFilter === "all") return true;

  const comment = comments.find((c) => c.id === id);

  if (isCommentVisible(commentFilter, comment?.commentReviewStatus)) {
    return true;
  }

  const hasMatchingChildren = comments.some((c) => {
    if (c.parentId === id) {
      return shouldShowCommentThread(c.id, comments, commentFilter);
    }
    return false;
  });

  return isCommentVisible(commentFilter, comment?.commentReviewStatus) || hasMatchingChildren;
};
